import { render, staticRenderFns } from "./OracleZjjhbList.vue?vue&type=template&id=ca20956a&scoped=true&"
import script from "./OracleZjjhbList.vue?vue&type=script&lang=js&"
export * from "./OracleZjjhbList.vue?vue&type=script&lang=js&"
import style0 from "./OracleZjjhbList.vue?vue&type=style&index=0&id=ca20956a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca20956a",
  null
  
)

export default component.exports